import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import ComingSoon from "@/components/shared/ComingSoon"
import routes from "@/routes/routes"

export const Scope1ComingSoon = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <ComingSoon
      title={t("comingSoonRoutes.scope1.title")}
      description={t("comingSoonRoutes.scope1.description")}
      notifyMeButtonText={t("comingSoonRoutes.scope1.cta")}
      onNotifyMeButtonClick={() => navigate(routes.climateSetup)}
    />
  )
}
